export default __webpack_public_path__ + "static/media/ico-elastic-cache-score-elevated.26af358b.svg";